/**
 * localStorage keys GlobalStateProvider used to mirror server data into.
 *
 * Outside mock mode these keys are never read back. `coach-clients` is never read
 * anywhere, and the nutrition keys are only rehydrated when `isMockMode()`. But they
 * were written in production anyway: unscoped by coach and never cleared on sign-out.
 * `coach-clients` embeds `coachNotes`, so a coach's private notes about clients stayed
 * in plaintext on shared devices. The provider no longer writes them outside mock mode;
 * this purge removes copies left by earlier builds, and runs again on sign-out.
 *
 * Deliberately NOT included: the legacy local-model keys (`coach-saved-workouts`,
 * `coach-client-programs`, `coachd-programs`, `coachd-client-programs`,
 * `coachd-client-events`, `coachd-program-templates`, `coach-food-items`,
 * `coach-workout-templates`). Those are still rehydrated in production, and for some of
 * them localStorage is the only copy, so purging could destroy a coach's data. Their
 * fate is decision D1 in docs/notes/2026-10-04-state-decomposition-plan.md.
 */
export const SERVER_DATA_MIRROR_KEYS = [
  'coach-clients',
  'coach-client-nutrition-plans',
  'coach-nutrition-templates',
] as const;

export function purgeServerDataMirror(storage: Storage = localStorage): void {
  for (const key of SERVER_DATA_MIRROR_KEYS) {
    try {
      storage.removeItem(key);
    } catch {
      // Storage unavailable (private mode / blocked site data) means nothing was persisted to purge.
    }
  }
}
